import { REGISTER_FIELDS } from './registers';
import type { ImportRegister } from './types';

const SYNONYMS: Record<string, string> = {
  firstname: 'first_name',
  givenname: 'first_name',
  lastname: 'last_name',
  surname: 'last_name',
  personkind: 'person_type',
  startdate: 'active_from',
  activefrom: 'active_from',
  dob: 'date_of_birth',
  birthdate: 'date_of_birth',
  externalkey: 'external_person_key',
  workerkey: 'worker_external_key',
  workerexternalkey: 'worker_external_key',
  screening: 'screening_type',
  screeningtype: 'screening_type',
  reference: 'reference_number',
  ref: 'reference_number',
  expiry: 'expires_on',
  expirydate: 'expires_on',
  issued: 'issued_on',
  issueddate: 'issued_on',
  authority: 'issuer',
  training: 'training_name',
  trainingname: 'training_name',
  course: 'training_name',
  coursename: 'training_name',
  completed: 'completed_on',
  completiondate: 'completed_on',
  certificateref: 'certificate_number',
  certificatenumber: 'certificate_number',
  policy: 'policy_reference',
  policyreference: 'policy_reference',
  policycode: 'policy_reference',
  policytitle: 'policy_reference',
  acknowledged: 'acknowledged_on',
  acknowledgementdate: 'acknowledged_on',
  acknowledgedon: 'acknowledged_on',
  policyversion: 'policy_version',
  evidencereference: 'evidence_reference',
};

const FIELDS: Record<ImportRegister, ReadonlySet<string>> = {
  WORKERS: new Set(REGISTER_FIELDS.WORKERS),
  SCREENINGS: new Set(REGISTER_FIELDS.SCREENINGS),
  TRAINING: new Set(REGISTER_FIELDS.TRAINING),
  POLICY_ACKNOWLEDGEMENTS: new Set(REGISTER_FIELDS.POLICY_ACKNOWLEDGEMENTS),
};

export function canonicalHeader(header: string): string {
  return header
    .trim()
    .toLowerCase()
    .replace(/[ _-]+/g, '');
}

export function matchedHeaders(
  headers: string[],
  register: ImportRegister,
): { fields: string[]; unknown: string[] } {
  const fields = headers.map((header) => {
    const canonical = canonicalHeader(header);
    return (
      SYNONYMS[canonical] ??
      [...FIELDS[register]].find((field) => canonicalHeader(field) === canonical) ??
      canonical
    );
  });
  return {
    fields,
    unknown: headers.filter((_header, index) => !FIELDS[register].has(fields[index] ?? '')),
  };
}

export function registerFields(register: ImportRegister): ReadonlySet<string> {
  return FIELDS[register];
}
